import React from 'react';


const About = () => {
    return (
        <div>
            <div class="hero min-h-0 h-96">
                <div class="hero-content flex-col lg:flex-row">
                    <div className=' text-center'>
                        <h1 class="text-5xl font-bold text-primary">Kaniz Fatima</h1>
                        <p class="py-6 text-lg">"I am a MERN stack web developer. I love to use my creativity and make something new. That's why I love to play with code. Over the last year, I gather knowledge in various parts of web development by myself. My ultimate goal is to become an awesome full-stack web developer who can make beautiful UIs and also can handle the back-end smoothly."</p>
                        <button class="btn btn-primary ">My Portfolio</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;